import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { Eye, EyeOff } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { GROWTHLY_LOGO_URL } from '../constants/branding';
export function Login() {
  const [key, setKey] = useState('');
  const [showKey, setShowKey] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const {
    isAuthenticated,
    loginWithKey
  } = useAuth();
  const navigate = useNavigate();
  if (isAuthenticated) {
    return <Navigate to="/app/dashboard" replace data-id="element-1039" />;
  }
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!key.trim()) return;
    setLoading(true);
    setError('');
    try {
      await loginWithKey(key);
      navigate('/app/dashboard', {
        replace: true
      });
    } catch (err: any) {
      setError(err.message || 'Llave inválida');
      setKey('');
    } finally {
      setLoading(false);
    }
  };
  return <div className="min-h-screen bg-[#0B0B0B] flex items-center justify-center p-4" data-id="element-1040">
      <div className="w-full max-w-[480px]" data-id="element-1041">
        {/* Logo */}
        <div className="text-center mb-8" data-id="element-1042">
          <div className="inline-flex items-center justify-center px-8 py-4 rounded-2xl bg-white mb-5 shadow-[0_8px_24px_rgba(0,0,0,0.4)]" data-id="element-1043">
            <img src={GROWTHLY_LOGO_URL} alt="Growthly" className="h-7 w-auto select-none" draggable={false} data-id="element-1044" />
          </div>
          <p className="text-[12px] uppercase tracking-[0.18em] text-[#9E9E9E]" data-id="element-1045">
            Corporation Systems
          </p>
        </div>

        {/* Card */}
        <div className="bg-white/[0.02] border border-white/[0.05] rounded-[12px] p-7" data-id="element-1046">
          <h2 className="text-[18px] font-semibold text-white mb-1" data-id="element-1047">
            Acceso al panel
          </h2>
          <p className="text-[13px] text-[#9E9E9E] mb-6" data-id="element-1048">
            Introduce tu llave de acceso para entrar.
          </p>

          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1049">
            <div data-id="element-1050">
              <label className="block text-[11px] uppercase tracking-wide text-[#9E9E9E] mb-1.5" data-id="element-1051">
                Llave de acceso
              </label>
              <div className="relative" data-id="element-1052">
                <input type={showKey ? 'text' : 'password'} value={key} onChange={e => setKey(e.target.value)} autoFocus placeholder="••••••••••••••••••" className="w-full h-12 pl-4 pr-11 bg-[#141414] border border-white/[0.05] rounded-lg text-white placeholder-[#5a5a5a] font-mono text-[14px] focus:border-[#27AE60] focus:outline-none transition-colors" data-id="element-1053" />
                <button type="button" onClick={() => setShowKey(s => !s)} aria-label={showKey ? 'Ocultar llave' : 'Mostrar llave'} className="absolute right-3 top-1/2 -translate-y-1/2 text-[#9E9E9E] hover:text-white transition-colors" data-id="element-1054">
                  {showKey ? <EyeOff size={16} data-id="element-1055" /> : <Eye size={16} data-id="element-1056" />}
                </button>
              </div>
            </div>

            {error && <div className="px-3 py-2 bg-[#D64545]/10 border border-[#D64545]/20 rounded-lg" data-id="element-1057">
                <p className="text-[13px] text-[#ff8e8e]" data-id="element-1058">{error}</p>
              </div>}

            <button type="submit" disabled={loading || !key.trim()} className="w-full h-11 bg-white text-[#0B0B0B] font-semibold rounded-lg hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center justify-center" data-id="element-1059">
              {loading ? <div className="w-5 h-5 border-2 border-[#0B0B0B]/20 border-t-[#0B0B0B] rounded-full animate-spin" data-id="element-1060" /> : 'Entrar al panel'}
            </button>
          </form>
        </div>

        <p className="text-center text-[11px] text-[#5a5a5a] mt-6" data-id="element-1061">
          Acceso restringido · {new Date().getFullYear()} Growthly Corporation
          Systems
        </p>
      </div>
    </div>;
}